import { lazy, Suspense } from "react";
import { Link } from "react-router-dom";
import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import TrustStrip from "@/components/landing/TrustStrip";
import HowItWorks from "@/components/landing/HowItWorks";
import StructuredData from "@/components/seo/StructuredData";

// Lazy load below-the-fold sections to reduce initial JS bundle
const IsThisForMe = lazy(() => import("@/components/landing/IsThisForMe"));
const Benefits = lazy(() => import("@/components/landing/Benefits"));
const MidPageCTA = lazy(() => import("@/components/landing/MidPageCTA"));
const Trustpilot = lazy(() => import("@/components/landing/Trustpilot"));
const AboutUs = lazy(() => import("@/components/landing/AboutUs"));
const MeetTheTeam = lazy(() => import("@/components/landing/MeetTheTeam"));
const FAQ = lazy(() => import("@/components/landing/FAQ"));
const ContactStrip = lazy(() => import("@/components/landing/ContactStrip"));
const Footer = lazy(() => import("@/components/landing/Footer"));
const TrustpilotBadge = lazy(() => import("@/components/landing/TrustpilotBadge"));
const StartNowFab = lazy(() => import("@/components/landing/StartNowFab"));

const SectionFallback = () => <div className="min-h-[200px]" />;

const Index = () => {
  return (
    <>
      <StructuredData />
      <Navbar />
      <main className="min-h-screen bg-background">
        <div className="bg-hero-bg">
          <Hero />
          <TrustStrip />
        </div>
        <HowItWorks />
        <Suspense fallback={<SectionFallback />}>
          <IsThisForMe />
        </Suspense>
        <Suspense fallback={<SectionFallback />}>
          <Benefits />
          <MidPageCTA />
          <Trustpilot />
          <AboutUs />
          <MeetTheTeam />
          <FAQ />
          <section className="py-12 px-4 bg-surface-cream">
            <div className="max-w-2xl mx-auto">
              <h2 className="text-xl font-bold text-foreground mb-2">Get the Pill Online</h2>
              <p className="text-sm text-muted-foreground mb-6">Free NHS contraceptive pill delivered to your door, no GP appointment needed.</p>
              <ul className="space-y-3 mb-10">
                {[
                  { to: "/get-the-pill-online/", label: "Get the pill online" },
                  { to: "/guides/how-to-get-the-pill/", label: "How to get the pill" },
                  { to: "/how-it-works/", label: "How it works" },
                  { to: "/guides/is-the-contraceptive-pill-free/", label: "Is the contraceptive pill free?" },
                  { to: "/guides/free-contraception-online/", label: "Free contraception online" },
                ].map((item) => (
                  <li key={item.to}>
                    <Link to={item.to} className="text-primary hover:underline text-sm font-medium">{item.label}</Link>
                  </li>
                ))}
              </ul>
              <h2 className="text-xl font-bold text-foreground mb-2">Learn More About the Pill</h2>
              <p className="text-sm text-muted-foreground mb-6">Pharmacist-reviewed guides to help you make informed choices.</p>
              <ul className="space-y-3">
                {[
                  { to: "/guides/which-contraceptive-pill-is-right-for-me/", label: "Which contraceptive pill is right for me?" },
                  { to: "/guides/is-contraception-direct-safe/", label: "Is Contraception Direct safe and legit?" },
                  { to: "/guides/what-is-the-combined-pill/", label: "What is the combined pill?" },
                  { to: "/guides/what-is-the-mini-pill/", label: "What is the mini pill?" },
                  { to: "/guides/side-effects-of-the-pill/", label: "Side effects of the pill" },
                  { to: "/guides/missed-pill-what-to-do/", label: "What to do if you miss a pill" },
                  { to: "/guides/best-contraceptive-pill/", label: "What is the best contraceptive pill?" },
                ].map((guide) => (
                  <li key={guide.to}>
                    <Link to={guide.to} className="text-primary hover:underline text-sm font-medium">{guide.label}</Link>
                  </li>
                ))}
              </ul>
              <Link to="/guides/" className="inline-block mt-4 text-sm font-semibold text-primary hover:underline">View all guides →</Link>
            </div>
          </section>
          <ContactStrip />
          <Footer />
        </Suspense>
        <Suspense fallback={null}>
          <TrustpilotBadge />
          <StartNowFab />
        </Suspense>
      </main>
    </>
  );
};

export default Index;
